import { RatingAndReviewsUI } from "./RatingAndReviewsUI";
import { StandardProps } from "@/components/componentMap";

export function RatingAndReviews({
  product,
  configProps,
  flags,
}: Pick<StandardProps, "product" | "configProps" | "flags">) {
  const { reviewSummary } = product;
  const hideRatings = configProps?.hideRatings === true;
  const suppressRatingLink = flags.suppressRatingLink.value === true;
  const moveReviewsSkipLink = flags.moveReviewsSkipLink.value === true;

  return (
    <RatingAndReviewsUI
      rating={
        reviewSummary && {
          averageRating: reviewSummary.averageRating,
          reviews: reviewSummary.numberOfReviews,
        }
      }
      hideRatings={hideRatings}
      suppressRatingLink={suppressRatingLink}
      moveReviewsSkipLink={moveReviewsSkipLink}
    />
  );
}
